import addEventListener from './addEventListener';
import removeEventListener from './removeEventListener';

function listen(node, eventName, handler, options) {
  addEventListener(node, eventName, handler, options);
  return function () {
    removeEventListener(node, eventName, handler, options);
  };
}

export default listen;


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/esm/listen.js
// module id = 586
// module chunks = 2